import type { FaireProductEntity } from "../../entity_types/product";

export const p_8dmqp2vv: FaireProductEntity = {
  token: "p_8dmqp2vv",
  type: "product",
  name: "Hello Sweet Bundle Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8886abe8654a1213947ce8edca55cb6f29b039efcc4e323c007cb9d4cda2b480/1528336432.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b967321407ebdf984625cb1647872e6d6727705eac636d164ed0f503478ecbaa/1528336432.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:58.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
